<form
  class="busca-global"
  role="search"
  aria-label="Buscar entradas"
  [class.busca-global--carregando]="carregando()"
  [attr.aria-busy]="carregando()"
  (submit)="pesquisar($event)"
>
  <p-iconfield class="busca-global__campo">
    @if (carregando()) {
      <p-inputicon class="pi pi-spin pi-spinner" />
    } @else {
      <p-inputicon class="pi pi-search" />
    }
    <input
      id="buscaGlobalEntrada"
      type="search"
      pInputText
      class="w-full"
      placeholder="Buscar entrada ou paciente"
      autocomplete="off"
      [formControl]="termoBusca"
      [attr.aria-describedby]="possuiMensagem() || exibirDicaPesquisa() ? 'buscaGlobalMensagem' : null"
      (input)="onTermoBuscaAlterado($event)"
    />
  </p-iconfield>
</form>

@if (possuiMensagem()) {
  <p id="buscaGlobalMensagem" class="busca-global__mensagem" aria-live="polite">{{ mensagem() }}</p>
} @else if (exibirDicaPesquisa()) {
  <p id="buscaGlobalMensagem" class="busca-global__mensagem" aria-live="polite">Pressione enter para pesquisar</p>
}

<p-dialog
  header="Entradas encontradas"
  [visible]="exibirDialog()"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [breakpoints]="modalBreakpoints"
  [style]="{ width: '70vw ' }"
  appendTo="body"
  (onHide)="fecharDialog()"
>
  <div class="flex flex-col gap-4">
    <p class="m-0 text-sm text-surface-600 dark:text-surface-300">
      Encontramos {{ quantidadeResultados() }} entradas. Selecione qual prontuário deseja abrir.
    </p>

    <p-table
      [value]="entradas()"
      dataKey="id"
      responsiveLayout="scroll"
      styleClass="p-datatable-sm p-datatable-gridlines"
      [lazy]="true"
      [paginator]="true"
      [rows]="tamanhoPagina"
      [first]="primeiraLinha()"
      [totalRecords]="totalRegistros()"
      [loading]="carregando()"
      (onLazyLoad)="aoAlterarPaginaBusca($event)"
    >
      <ng-template pTemplate="caption">
        <span class="sr-only">Lista de entradas encontradas na busca global</span>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th scope="col">Entrada</th>
          <th scope="col">Paciente</th>
          <th scope="col">Situação</th>
          <th scope="col">Área</th>
          <th scope="col">Data</th>
          <th scope="col" class="w-20 text-center">Ações</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-entrada>
        <tr>
          <td class="font-semibold">#{{ entrada.id }}</td>
          <td>
            <div class="flex flex-col gap-1">
              <span class="font-medium">{{
                entrada.paciente.nomeCivil || entrada.paciente.nome || "Nome não informado"
              }}</span>
              @if (entrada.paciente.nomeSocial) {
                <span class="text-xs text-surface-500">Nome social: {{ entrada.paciente.nomeSocial }}</span>
              }
            </div>
          </td>
          <td>
            {{ entrada.situacaoEntrada.descricao || "Sem situação" }}
          </td>
          <td>{{ entrada.areaEntrada.nome || entrada.area?.nome || "Sem área" }}</td>
          <td>
            {{ (entrada.dataHora | dataHoraFormatted) || (entrada.dataHoraCadastro | dataHoraFormatted) || "Sem data" }}
          </td>
          <td class="text-center">
            <p-button
              type="button"
              size="small"
              severity="primary"
              icon="pi pi-eye"
              pTooltip="Abrir prontuário"
              tooltipPosition="left"
              (onClick)="abrirProntuario(entrada.id)"
              aria-label="Abrir prontuário da entrada"
            />
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-dialog>
